import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ScanLogo from "./ScanLogo";

function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  
  const goToSection = (id) => {
    navigate("/");

    setTimeout(() => {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  return (
    <div className="w-full fixed top-0 z-50 bg-black/50 backdrop-blur-md border-b border-green-500/10">
      
      <div className="max-w-7xl mx-auto flex justify-between  items-center px-6 py-8">
        
        {/* Logo */}
<div className="flex items-center gap-2">
  <ScanLogo/>

  <h1 
    onClick={() => goToSection("home")}
    className="text-xl font-bold text-green-400 tracking-widest cursor-pointer"
  >
    PRINTEZZ_
  </h1>
</div>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8 text-sm text-gray-300">
          
          <button 
            onClick={() => goToSection("home")} 
            className="hover:text-green-400 transition"
          >
            HOME
          </button>

          <button 
            onClick={() => goToSection("services")} 
            className="hover:text-green-400 transition"
          >
            SERVICES
          </button>

          <Link 
            to="/contact" 
            className="hover:text-green-400 transition"
          >
            CONTACT
          </Link>

         <Link to="/about" className="hover:text-green-400">
  ABOUT US
</Link>
        </div>

        {/* Desktop Button */}
        <button  onClick={() => window.open("https://app.printezz.com/", "_blank")}  className="hidden md:block border border-green-400 text-green-400 px-5 py-2 text-sm 
        hover:bg-green-400 hover:text-black transition shadow-[0_0_10px_#00ff9f]">
          START PRINTING NOW →
        </button>

        {/* Hamburger */}
        <div 
          className="md:hidden cursor-pointer flex flex-col gap-1"
          onClick={() => setOpen(!open)}
        >
          <div className={`w-6 h-[2px] bg-green-400 transition-all duration-300 
          ${open ? "rotate-45 translate-y-[6px]" : ""}`}></div>

          <div className={`w-6 h-[2px] bg-green-400 transition-all duration-300 
          ${open ? "opacity-0" : ""}`}></div>

          <div className={`w-6 h-[2px] bg-green-400 transition-all duration-300 
          ${open ? "-rotate-45 -translate-y-[6px]" : ""}`}></div>
        </div>
      </div>

      {/* 🚀 MOBILE MENU (CENTER FIXED) */}
      <div
        className={`md:hidden bg-black/95 backdrop-blur-md transition-all duration-500 overflow-hidden
        ${open ? "max-h-[500px] py-8" : "max-h-0"}`}
      >
        <div className="flex flex-col items-center justify-center gap-6 text-lg font-medium text-gray-300">

          <button 
            onClick={() => { goToSection("home"); setOpen(false); }} 
            className="hover:text-green-400 transition"
          >
            HOME
          </button>

          <button 
            onClick={() => { goToSection("services"); setOpen(false); }} 
            className="hover:text-green-400 transition"
          >
            SERVICES
          </button>

          <Link 
            to="/contact" 
            onClick={() => setOpen(false)} 
            className="hover:text-green-400 transition"
          >
            CONTACT
          </Link>

          <Link 
            to="/about" 
            onClick={() => setOpen(false)} 
            className="hover:text-green-400 transition"
          >
            ABOUT US
          </Link>

          <button   onClick={() => {
    window.open("https://app.printezz.com/", "_blank");
    setOpen(false);
  }}  className="mt-4 border border-green-400 text-green-400 px-6 py-2 
          hover:bg-green-400 hover:text-black transition shadow-[0_0_10px_#00ff9f]">
            START PRINTING NOW →
          </button>

        </div>
      </div>
    </div>
  );
}

export default Navbar;